export default "__VITE_ASSET__047975ec__"